var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_plus",
    "data-name": "icon - plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M9.855,13.755H5.544a1.56,1.56,0,0,1-1.56-1.56v-.78a1.56,1.56,0,0,1,1.56-1.56H9.855V5.544a1.56,1.56,0,0,1,1.56-1.56h.78a1.56,1.56,0,0,1,1.56,1.56V9.855h4.311a1.56,1.56,0,0,1,1.56,1.56v.78a1.56,1.56,0,0,1-1.56,1.56H13.755v4.311a1.56,1.56,0,0,1-1.56,1.56h-.78a1.56,1.56,0,0,1-1.56-1.56Z",
    transform: "translate(1.195 1.195)",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.e95224a16a800290b9b6ea77a6a0a855.svg";
export { ForwardRef as ReactComponent };